<div class="parent">
	<div class="container px-0">
		<div class="footer-social-media-block">
			<div class="block-1">
				<a href="https://www.facebook.com/profile.php?id=100093694385584" target="_blank"><img
						src="./assets/images/footer/f-facebook.png" alt="Facebook icon"></a>
				<a href="https://www.youtube.com/@Ausmit" target="_blank"><img
						src="./assets/images/footer/f-youtube.png" alt="YouTube icon"></a>
				<a href="https://www.instagram.com/ausmit_india/?igsh=d2xrcnRyOTcwdHZj" target="_blank"><img
						src="./assets/images/footer/f-instagram.png" alt="Instagram icon"></a>
				<a href="https://www.linkedin.com/company/ausmit" target="_blank"><img
						src="./assets/images/footer/f-linkedIn.png" alt="LinkedIn icon"></a>
			</div>
			<div class="block-2">
				© {{currYear}} Ausmit. All rights reserved.
			</div>
			<div class="block-3">
				<a href="https://play.google.com/store/apps/details?id=com.ausmit.app" target="_blank"><img
						src="./assets/images/footer/google.png" alt="Google Play Store icon"></a>
				<!-- <a href="javascript:void(0)"><img src="./assets/images/footer/apple.png"></a> -->
			</div>
		</div>
	</div>
</div>